'use strict';

class AeroModal {
  constructor() {
    this.modal = document.getElementById('aero-modal');
    this.modalTitle = document.getElementById('modal-title');
    this.modalContent = document.getElementById('modal-content');
    this.isOpen = false;
    this.modalData = {};

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    // Initialize
    this.init();
  }

  init() {
    // Set up event listeners for all modal triggers
    document.querySelectorAll('[data-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-trigger');
        this.open(modalId);
      });
    });

    // Close button event listener
    const closeButton = this.modal.querySelector('[data-micromodal-close]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close);
    }

    // Outside click event listener
    this.modal.addEventListener('click', this.handleOutsideClick);
  }

  open(modalId) {
    // Get modal content from the data attribute
    const trigger = document.querySelector(`[data-modal-trigger="${modalId}"]`);
    if (!trigger) return;

    this.modalData = {
      title: trigger.getAttribute('data-modal-title'),
      content: trigger.getAttribute('data-modal-content')
    };

    // Update modal content
    this.modalTitle.textContent = this.modalData.title;
    this.modalContent.innerHTML = this.modalData.content;

    // Show modal
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;

    // Add escape key listener
    document.addEventListener('keydown', this.handleEscapeKey);
  }

  close() {
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.isOpen = false;

    // Remove escape key listener
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }

  handleOutsideClick(e) {
    if (e.target.hasAttribute('data-micromodal-close')) {
      this.close();
    }
  }
}

// Initialize modal when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.aeroModal = new AeroModal();
}); 